import { createTranslationsHook as _createTranslationsHook } from '@rematter/ui-web/lib';
import { getDefaultStore, useAtomValue } from 'jotai';

import { $localization } from '../state/preferences.state';

export const createTranslationsHook = <T>(translations: {
  en: T;
  es?: T;
  pt?: T;
  fr?: T;
  de?: T;
}) => {
  const getTranslations = _createTranslationsHook(translations, {
    getLanguage: () => getDefaultStore().get($localization).language,
  });

  return () => {
    useAtomValue($localization);
    return getTranslations();
  };
};
